import { useRouteError } from 'react-router';

import type { Logger, BaseConfig } from '../../../';
import { ErrorBoundary } from './ErrorBoundary';

interface Props {
  logger: Logger;
  config: BaseConfig;
}

export function ErrorBoundaryContainer({ logger, config }: Props) {
  const error = useRouteError() as any;

  logger.error(
    {
      routeError: {
        ...error,
        graphQLErrorsStringified: JSON.stringify(error.graphQLErrors || []),
        networkError: {
          ...error.networkError,
          result: JSON.stringify(error.networkError?.result || []),
        },
      },
    },
    'ErrorBoundary caught an error',
  );

  return <ErrorBoundary config={config} />;
}
